import { baseResourceOptions } from './utils';
import emptyObserverCreator from '../shared/emptyObserverCreator';
import { SidekickCustomer } from 'src/models/Sidekick/SidekickCustomer';
import createDocumentResource from '../shared/createDocumentResource';

const sidekickCustomerResource = createDocumentResource<SidekickCustomer>({
  name: 'sidekickCustomer',
  endpoint: 'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/customers/:customerId',
  type: SidekickCustomer,
  observerCreator: emptyObserverCreator,
  options: baseResourceOptions,
});

export default sidekickCustomerResource;
